import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { reducer as beachReducer } from "./beach";
import { reducer as cityReducer } from "./city";
import { reducer as holderReducer } from "./holder";
import { reducer as officerReducer } from "./officer";
import rootSaga from "./saga";
import { reducer as userReducer } from "./user";
const sagaMiddleware = createSagaMiddleware();
const middleware = [...getDefaultMiddleware({ thunk: false }), sagaMiddleware];

export const store = configureStore({
  reducer: {
    holder: holderReducer,
    user: userReducer,
    officer: officerReducer,
    city: cityReducer,
    beach: beachReducer,
  },
  middleware,
});

export type RootState = ReturnType<typeof store.getState>;

sagaMiddleware.run(rootSaga);
